import React, { Fragment } from 'react'
import { Image } from '~/components/Photos'
import type { StepsSection as Settings } from '~/types'
import { cn } from '~/utils'
import { Section, Title } from './Common'

interface Props {
	section: Settings
}

export const StepsSection: React.FC<Props> = ({ section }) => (
	<Section
		tag={section.tag}
		className="my-20 space-y-12 py-24 text-center lg:space-y-16 lg:!py-28"
		style={{
			backgroundColor: section.settings.background_color,
			color: section.settings.text_color,
			textAlign: section.settings.text_align
		}}
	>
		<Title>{section.settings.title}</Title>
		<div
			className="text-16 self-start md:row-start-2"
			dangerouslySetInnerHTML={{ __html: section.settings.text }}
		/>
		<div className="list grid items-center gap-y-8 md:auto-cols-[5fr_1fr] md:grid-flow-col md:gap-y-4">
			{section.blocks.map(({ id, settings }, i) => (
				<Fragment key={id}>
					<h3 className="text-24 m-0 leading-none md:row-start-1">{settings.title}</h3>
					{settings.text && (
						<p
							className="text-16 self-start md:row-start-2"
							dangerouslySetInnerHTML={{ __html: settings.text }}
						/>
					)}
					<Image
						className={cn(
							'h-100 justify-self-center rounded-full object-cover md:row-start-3 md:h-64 md:w-64',
							i < section.blocks.length - 1 ? 'mb-20' : 'mb-8',
							'md:mb-0'
						)}
						src={settings.image}
					/>
					<div
						className={cn('row-start-1 hidden h-0.5 bg-green-600', {
							'md:block': i < section.blocks.length - 1
						})}
					/>
				</Fragment>
			))}
		</div>
	</Section>
)
